export default __webpack_public_path__ + "static/media/beta-icon.80c81959.png";